/**
 * This file is generated from scripts/genIconComponents.js. Any
 * changes should be made in that file.
 */
import React, { forwardRef, Ref } from "react";
import { getSvgResourceForSize, getDefaultSize } from "../../utils";
import { Icon, LodestarIconProps } from "../../icon";
import { SvgArrowDown as ArrowDownMedium } from "./medium/ArrowDown";
const sizeMap = {
    medium: ArrowDownMedium,
};
const defaultSize = getDefaultSize(sizeMap);

export const ArrowDownIcon = forwardRef(
    (
        { size = defaultSize, ...rest }: LodestarIconProps,
        ref: Ref<HTMLElement>
    ) => (
        <Icon
            ref={ref}
            svgComponent={getSvgResourceForSize(sizeMap, size)}
            size={size}
            {...rest}
        />
    )
);
ArrowDownIcon.displayName = "ArrowDownIcon";
